import { withLocalState } from 'pyradux';

import ClientModalContainer from './ClientModal.container';
import reducer from './ClientModal.reducer';
import ClientModalSagas from './ClientModal.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'clientModal',
  sagas: [ClientModalSagas],
};

export default withLocalState(withLocalStateOptions, ClientModalContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/ClientModal/index.js